<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="公司名称" prop="company">
                            <Input v-model="Forms.company" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系人" prop="real_name">
                            <Input v-model="Forms.real_name" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话" prop="mobile">
                            <Input v-model="Forms.mobile" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="公司地址" prop="address">
                            <Input v-model="Forms.address" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="bank">
                            <Input v-model="Forms.bank" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="银行账号" prop="account">
                            <Input v-model="Forms.account" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="状态：">
                            <RadioGroup v-model="Forms.status" type="button">
                                <Radio :label="1">审核</Radio>
                                <Radio :label="2">禁用</Radio>
                                <Radio :label="3">开启</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认创建公司</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getInvoiceCompanyDetail, saveInvoiceCompany} from "@/apis/invoice/company";

export default {
    name: 'CreateCompany',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '创建公司',
            isBox : false,
            Forms : {
                id:'',
                company: '',
                real_name: '',
                mobile: '',
                address: '',
                bank: '',
                account: '',
                status: 3
            },
            Rules : {
                company: [
                    { required: true, message: '请输入公司名称', trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getInvoiceCompanyDetail(id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'status') {
                        that.Forms[v] = parseInt(data[v]);
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
                that.title = '编辑公司';
            })
        },
        /**
         功能：
         time: 2025/12/25 16:08
         **/
        add(){
            this.isBox = true;
        },
        /**
         功能：
         time: 2026/1/7 09:50
         **/
        edit(id){
            this.isBox = true;
            this.GetDetail(id);
        },
        /**
         功能：
         time: 2026/1/7 09:41
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveInvoiceCompany(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2026/1/7 09:41
         **/
        FormReset(){
            this.isBox = false;
            this.title = '创建公司';
            this.$refs['Forms'].resetFields();
            this.Forms.id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
